<form
  [formGroup]="form"
  class="container mt-4">
  <div class="row justify-content-center">
    <div class="col-12 col-md-9 col-lg-6">
      <div class="pt-md-3">
        <div class="question-title">
          {{ 'bvs.calculator.additionalInsurance' | transloco }}
        </div>

        <div class="mb-4">
          <app-additional-coverage-box
            [ctrl]="form.controls.figures.controls.isCharterSelected"
            [icon]="'pi-users'"
            [text]="'bvs.calculator.isCharterText'"
            [title]="'bvs.calculator.isCharterTitle'"></app-additional-coverage-box>
        </div>

        <div class="mb-4">
          <app-additional-coverage-box-for-enum
            [ctrl]="form.controls.figures.controls.callidusBvsVersicherungssummeKunde"
            [icon]="'pi-shield'"
            [switchValues]="[CallidusBvsVersicherungssummeKunde.Versicherungssumme5Mio, CallidusBvsVersicherungssummeKunde.Versicherungssumme10Mio]"
            [text]="'bvs.calculator.bvsNepKundeText'"
            [title]="'bvs.calculator.bvsNepKundeTitle'"></app-additional-coverage-box-for-enum>
        </div>

        <div class="mb-4">
          <app-additional-coverage-box
            [ctrl]="form.controls.figures.controls.isRechtsschutzSelected"
            [icon]="'pi-id-card'"
            [text]="'bvs.calculator.isRechtsschutzText'"
            [title]="'bvs.calculator.isRechtsschutzTitle'"></app-additional-coverage-box>
        </div>

        @if (form.controls.figures.controls.isRechtsschutzSelected.value) {
          <div class="mb-4">
            <app-additional-coverage-box
              [ctrl]="form.controls.figures.controls.isKeinSelbstbehaltBeiRechtsschutzSelected"
              [icon]="'pi-id-card'"
              [text]="'bvs.calculator.isSelbstbehaltText'"
              [title]="'bvs.calculator.isSelbstbehaltTitle'"></app-additional-coverage-box>
          </div>
        }

        @if (showCalculationPremiumEnabled) {
          <div
            [ngClass]="getPremiumColorCode(this.haftpflichtCalculationResult)"
            class="card-body mb-4 box-shadow">
            @if (showInsurancePremium()) {
              <div class="mb-5">
                <app-premium-display
                  [additionalHint]="form.controls.figures.controls.isRechtsschutzSelected.value === true ? ('bvs.calculator.isRechtsschutzHint'|transloco) : null"
                  [premiumValue]="haftpflichtCalculationResult?.versicherungspraemieInEur!"></app-premium-display>
              </div>
            }
            @if (showErrorMessages()) {
              <app-calculation-error-display
                [result]="haftpflichtCalculationResult"></app-calculation-error-display>
            }
          </div>
        }
      </div>

      <div class="mb-5 d-flex justify-content-center">
        <button
          (click)="prev.emit()"
          class="btn btn-sm btn-secondary">
          {{ 'shared.back' | transloco }}
        </button>
        <button
          (click)="next.emit()"
          class="btn btn-sm btn-primary"
          data-cy="continueToCustomerData">
          {{ 'bvs.calculator.continueToCustomerData' | transloco }}
        </button>
      </div>
    </div>
  </div>
</form>
